import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import { Authority } from '../models';

@Injectable({ providedIn: 'root' })
export class AdminContractingAuthoritiesApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).apiBaseUrl}/api/admin/BackofficeContractingAuthorities`;

  getContractingAuthorities(request?: { regions?: string[] }) {
    let params = new HttpParams();

    if (request?.regions && request.regions.length > 0) {
      params = params.append('regions', request.regions.join(','));
    }

    return this.httpClient.get<Authority[]>(`${this.baseUrl}`, { params });
  }

  searchContractingAuthorities(request?: { query?: string }) {
    let params = new HttpParams();

    if (request?.query) {
      params = params.append('query', request.query);
    }

    return this.httpClient.get<Authority[]>(`${this.baseUrl}/search`, {
      params,
    });
  }

  getContractingAuthorityById(id: string) {
    return this.httpClient.get<Authority>(`${this.baseUrl}/${id}`);
  }
}
